import { Modal, Spinner, Text } from "native-base";
import * as React from "react";
import { useTranslation } from "react-i18next";
import Colors from "../../const/Colors";

const AiLoadingView = () => {
  //=========== HOOK ==========
  const { t } = useTranslation();

  //=========== OUT ==========
  return (
    <Modal isOpen={true} background={"rgba(0,0,0,0.5)"}>
      <Spinner color={Colors.primaryColor} size={40} padding={2} />
      <Text color={Colors.primaryColor}>{t("diagnosticProcessing")}</Text>
    </Modal>
  );
};

export default AiLoadingView;
